import {
  Box,
  Typography,
  Container,
  useTheme,
  Divider,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";

function Terms() {
  const theme = useTheme();
  const { t } = useTranslation();
  const currentContent = t("terms", { returnObjects: true });

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: { xs: 4, sm: 6 },
        backgroundColor: "#f5f7fa",
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={3}
          sx={{ p: { xs: 3, sm: 4 }, backgroundColor: "#fff", borderRadius: 3 }}
        >
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{ fontWeight: "bold" }}
            >
              {t("terms.title")}
            </Typography>
            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{ color: theme.palette.text.secondary }}
            >
              {t("terms.appName")} — {t("terms.contact")}
            </Typography>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Typography variant="body1" paragraph sx={{ mb: 3 }}>
            {t("terms.intro")}
          </Typography>

          {currentContent.sections.map((section, index) => (
            <Box key={index} sx={{ mb: 4 }}>
              <Typography
                variant="h6"
                component="h2"
                gutterBottom
                sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
              >
                {section.title}
              </Typography>
              {section.items.map((item, itemIndex) => (
                <Typography
                  key={itemIndex}
                  variant="body2"
                  paragraph
                  sx={{ ml: item.trim().startsWith("-") ? 2 : 0 }}
                >
                  {item}
                </Typography>
              ))}
              {index !== currentContent.sections.length - 1 && (
                <Divider sx={{ mt: 3 }} />
              )}
            </Box>
          ))}
        </Paper>
      </Container>
    </Box>
  );
}

export default Terms;
